import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {UserService} from './user.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class BiometryGuard implements CanActivate {
  constructor(private userService: UserService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    if (state.url.indexOf('/dashboard/biometry') === 0) {
      return true;
    }
    return this.userService.isMyBiometryRequired()
      .map((response: any) => {
        const body = response && response.body ? response.body : {};
        if (body.biometryRequired) {
          this.router.navigate(['/dashboard/biometry'], {queryParams: {returnUrl: state.url}});
          return false;
        }
        return true;
      })
      .catch(() => Observable.of(true));
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/biometry-guard.service.ts